"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPricingDataSchema = exports.PricingCacheEntrySchema = exports.SKUPricesSchema = exports.PriceBreakSchema = exports.BOMPricesSchema = exports.MPNPricesSchema = exports.DistributorPricesSchema = exports.TimestampSchema = exports.NumericSKURangeSchema = void 0;
const zod_1 = require("zod");
exports.NumericSKURangeSchema = zod_1.z.object({
    min: zod_1.z.union([zod_1.z.number(), zod_1.z.nan()]).nullable(),
    minSkuId: zod_1.z.string().nullable(),
    max: zod_1.z.union([zod_1.z.number(), zod_1.z.nan()]).nullable(),
    maxSkuId: zod_1.z.string().nullable(),
});
// NOTE: union type because Firestore weird date handling
exports.TimestampSchema = zod_1.z.union([
    zod_1.z.date(),
    zod_1.z.object({
        seconds: zod_1.z.number(),
        nanoseconds: zod_1.z.number(),
        // TODO: toDate is not working when reading from cache entries, probably
        // because the Firestore Timestamp is serialized to JSON and needs to be
        // re-created on read. Same for toMillis and valueOf.
        toDate: zod_1.z.function().returns(zod_1.z.date()),
        toMillis: zod_1.z.function().returns(zod_1.z.number()),
        valueOf: zod_1.z.function().returns(zod_1.z.string()),
    }),
]);
exports.DistributorPricesSchema = zod_1.z.object({
    skuCount: zod_1.z.number(),
    skuIds: zod_1.z.array(zod_1.z.string()),
    dpns: zod_1.z.array(zod_1.z.string()),
    stockRange: exports.NumericSKURangeSchema,
    priceRange: exports.NumericSKURangeSchema,
    listingUrl: zod_1.z.string().nullable(),
    lifeCycleStatus: zod_1.z.string().optional(),
    timestamp: exports.TimestampSchema.nullable(),
});
exports.MPNPricesSchema = zod_1.z.object({
    type: zod_1.z.literal("mpn"),
    mpn: zod_1.z.string(),
    skuCount: zod_1.z.number(),
    skuIds: zod_1.z.array(zod_1.z.string()),
    timestamp: exports.TimestampSchema.nullable(), // The timestamp of the caching
    distributorPrices: zod_1.z.record(exports.DistributorPricesSchema),
});
exports.BOMPricesSchema = zod_1.z.object({
    type: zod_1.z.literal("bom"),
    cacheKey: zod_1.z.string(),
    quantityTarget: zod_1.z.number(),
    currency: zod_1.z.string(),
    mpnQuantities: zod_1.z.record(zod_1.z.number()),
    minCost: zod_1.z.number(),
    maxCost: zod_1.z.number(),
    timestamp: exports.TimestampSchema.nullable(),
    caveats: zod_1.z.array(zod_1.z.object({ mpn: zod_1.z.string(), caveat: zod_1.z.string() })),
    distributorCosts: zod_1.z.record(zod_1.z.object({
        minCost: zod_1.z.number(),
        maxCost: zod_1.z.number(),
        timestamp: exports.TimestampSchema.nullable(),
    })),
});
exports.PriceBreakSchema = zod_1.z.object({
    quantity: zod_1.z.number(),
    unitPrice: zod_1.z.number(),
});
exports.SKUPricesSchema = zod_1.z.object({
    type: zod_1.z.literal("sku"),
    skuId: zod_1.z.string(),
    dpn: zod_1.z.string(),
    mpn: zod_1.z.string(),
    distributor: zod_1.z.string(),
    distributorId: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    datasheetUrl: zod_1.z.string().nullable(),
    listingUrl: zod_1.z.string().nullable(),
    availableQuantity: zod_1.z.number().nullable(),
    minimumOrderQuantity: zod_1.z.number().nullable(),
    leadTimeDays: zod_1.z.number().nullable(),
    priceBreaks: zod_1.z.array(exports.PriceBreakSchema),
    lifecycleStatus: zod_1.z.string().nullable(),
    packagingOptions: zod_1.z.array(zod_1.z.string()).nullable(),
    timestamp: exports.TimestampSchema.nullable(),
});
exports.PricingCacheEntrySchema = zod_1.z.discriminatedUnion("type", [
    exports.BOMPricesSchema,
    exports.MPNPricesSchema,
    exports.SKUPricesSchema,
]);
const PriceSnapshotSchema = zod_1.z.object({
    amount: zod_1.z.number(),
    scale: zod_1.z.number(),
    currency: zod_1.z.object({
        code: zod_1.z.string(),
        base: zod_1.z.number().or(zod_1.z.array(zod_1.z.number())),
        exponent: zod_1.z.number(),
    }),
});
const PriceRangeSchema = zod_1.z.object({
    minCost: PriceSnapshotSchema,
    maxCost: PriceSnapshotSchema,
});
const BOMCostCaveatSchema = zod_1.z.object({
    caveat: zod_1.z.string(),
    mpn: zod_1.z.string(),
    distributorsSearched: zod_1.z.array(zod_1.z.string()),
    error: zod_1.z.string(),
});
const BOMCostSchema = zod_1.z.intersection(PriceRangeSchema, zod_1.z.object({
    distributorCosts: zod_1.z.record(PriceRangeSchema.or(zod_1.z.null())),
    caveats: zod_1.z.array(BOMCostCaveatSchema).nullable(),
}));
exports.DocumentPricingDataSchema = zod_1.z.object({
    timestamp: zod_1.z.preprocess((val) => (typeof val.toDate === "function" ? val.toDate() : val), zod_1.z.date()),
    elementCount: zod_1.z.number(),
    partCount: zod_1.z.number(),
    bomCost: BOMCostSchema,
});
//# sourceMappingURL=pricing.js.map